{
  "version": 1,
  "asset_id": "5c014a17-31e5-4996-acc7-5cc0d9caa994",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/5c014a17-31e5-4996-acc7-5cc0d9caa994/bbb.webp",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/5c014a17-31e5-4996-acc7-5cc0d9caa994/bbb.webp",
  "original_filename": "bbb.webp",
  "size": 5166,
  "content_type": "image/webp",
  "created_at": "2026-06-26T16:55:08Z"
}
